<bic-popup (close)="(displayQrCode || displayMfaForm) ? deactivate2FA() : closeAfterSuccess()" [hasBackdrop]="true" customClass="h-[500px] w-[400px]"
  [title]="'2FA Einrichtung'">
  <div bicPopupContent class="flex flex-col h-full">
    @if (displayQrCode) {
      <div class="flex flex-col items-center">
        <span>Scannen Sie den QR-Code mit Ihrer Authenticator-App.<br><br></span>
        @if (qrCodeString) {
          <img [src]="qrCodeString" alt="QR Code" width="300px">
        }
      </div>
    }
    @if (displayMfaForm) {
        @if (!data.isMail) {
          <span class="flex flex-col">Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.</span>
        }
        @if (data.isMail) {
          <span class="flex flex-col">Geben Sie den 6-stelligen Code aus Ihrer Mail ein.</span>
        }
        <div class="flex-1 flex flex-col justify-center  w-full">
          <!--              <label for="code" class="block text-sm mb-1 font-medium text-white">2FA Code</label>-->
          <div [formGroup]="mfaForm" class="flex flex-row justify-between w-full pb-6" id="code">
            <input #otpInput (input)="moveToNext($event, 0)" (keydown)="moveToNext($event, 0)" (paste)="moveToNext($event, 0)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code1" maxlength="1" type="number">
            <input #otpInput (input)="moveToNext($event, 1)" (keydown)="moveToNext($event, 1)" (paste)="moveToNext($event, 1)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code2" maxlength="1" type="number">
            <input #otpInput (input)="moveToNext($event, 2)" (keydown)="moveToNext($event, 2)" (paste)="moveToNext($event, 2)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code3" maxlength="1" type="number">
            <input #otpInput (input)="moveToNext($event, 3)" (keydown)="moveToNext($event, 3)" (paste)="moveToNext($event, 3)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code4" maxlength="1" type="number">
            <input #otpInput (input)="moveToNext($event, 4)" (keydown)="moveToNext($event, 4)" (paste)="moveToNext($event, 4)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code5" maxlength="1" type="number">
            <input #otpInput (input)="moveToNext($event, 5)" (keydown)="moveToNext($event, 5)" (paste)="moveToNext($event, 5)"
                   [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                   class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                   formControlName="code6" maxlength="1" type="number">
          </div>
          @if (mfaForm.get('code1')?.touched && mfaForm.get('code1')?.invalid) {
            @if (mfaForm.get('code1')?.errors?.required) {
              <span class="text-xs text-red pt-1">Sie müssen den 2FA Code eingeben.</span>
            }
            @if (mfaForm.get('code1')?.errors?.pattern) {
              <span class="text-xs text-red pt-1">Der Code muss 6 Ziffern lang sein.</span>
            }
          }
          @if (mfaError) {
            <span class="text-xs text-red pt-1">Der eingegebene Code ist nicht korrekt.</span>
          }
              @if (data.isMail) {
<span class="text-sm text-green items-start" mat-dialog-close>Code nicht erhalten?</span>
}
              @if (!data.isMail) {
<span class="text-sm text-green items-start" mat-dialog-close>Keinen Zugriff auf die App?</span>
}
        </div>

    }
    @if (displayMfaSuccess) {
      <div class="flex-1 flex flex-col justify-center items-center w-full">
        <fa-icon [icon]="faShieldCheck" class="text-green text-[96px]"></fa-icon>
        <span class="text-base text-green font-medium">2FA erfolgreich aktiviert</span>
      </div>
    }
  </div>
    <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
      @if(displayQrCode) {
        <bic-button (onClick)="deactivate2FA()" [loading]="isDeactivateLoading" buttonType="white">Abbrechen
        </bic-button>
        <bic-button (onClick)="displayQrCode = false; displayMfaForm = true">Weiter</bic-button>
      }
      @if(displayMfaForm) {
        <bic-button (onClick)="deactivate2FA()" [loading]="isDeactivateLoading" buttonType="white">Abbrechen
        </bic-button>
        <bic-button (onClick)="verify()" [loading]="isVerifyLoading || isActivationLoading">Weiter</bic-button>
      }
      @if(displayMfaSuccess) {
        <bic-button (onClick)="closeAfterSuccess()">Fertig</bic-button>
      }
    </div>
</bic-popup>
